import { Button } from './Button';
import { useNavigate } from 'react-router';

export type ReloadHandler = () => void;

export interface ReloadButtonProps {
  text?: string;
  reload?: ReloadHandler;
  variant?: React.ComponentProps<typeof Button>['variant'];
  size?: React.ComponentProps<typeof Button>['size'];
}

const ReloadButton = ({ text, reload, variant = 'primary', size = 'md' }: ReloadButtonProps) => {
  const navigate = useNavigate();
  const handleReload = () => {
    if (reload) {
      reload();
      return;
    }
    // router.refresh();
    navigate(0);
  };

  return (
    <Button onClick={handleReload} icon="refresh" variant={variant} size={size}>
      {text ? text : 'Reload'}
    </Button>
  );
};

export default ReloadButton;
